import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

const Analytics = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics
    ReactGA.initialize('G-ES11CM1S5D'); // Replace with your Measurement ID
  }, []);

  useEffect(() => {
    // Send pageview with updated location
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  // Helper function to track events
  const trackEvent = (category, action, label) => {
    ReactGA.event({
      category,
      action,
      label
    });
  };

  // Use render prop pattern to pass trackEvent to children
  return children({ trackEvent });
};

export default Analytics;